"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _dcCore = require("dc-core");
var _classnames = _interopRequireDefault(require("classnames"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _reactSwipeable = require("react-swipeable");
var _ComponentRegistry = _interopRequireDefault(require("../../../../util/ComponentRegistry"));
var _AppUtil = require("../../../../util/AppUtil");
var _PreviewError = _interopRequireDefault(require("../../error/presentation/PreviewError"));
var _fullScreenModal = _interopRequireDefault(require("../../full-screen-modal"));
require("!style-loader!css-loader!./../presentation/Preview.css");
var _class, _class2, _descriptor;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
/**
 * @class
 * This container takes care of file preview by loading dc preview component
 */
let PreviewContainer = exports.default = (0, _mobxReact.observer)(_class = (_class2 = class PreviewContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "previewDropin", _descriptor, this);
    this._loggingService = _ServiceRegistry.default.getService("LoggingService");
    this._appStore = _ServiceRegistry.default.getService("AppStore");
    this._loggingService.logExternal("File preview attached.");
    _dcCore.providers.discovery().then(discovery => {
      discovery.loadDropinClass("preview").then(Dropin => {
        _ServiceRegistry.default.getService("PerformanceService").setPreviewDropinReadyToRender();
        this.setPreviewDropin(Dropin);
      }).catch(error => {
        this._loggingService.error("PreviewContainer", "Error in loading preview dropin", error);
      });
    });
  }
  setPreviewDropin(value) {
    this.previewDropin = value;
  }
  getComponent() {
    const hideCSS = !this._appStore.getConfig().showSimpleLoader && !this._appStore.fileLoaded;
    if (this._appStore.previewError) {
      return /*#__PURE__*/_react.default.createElement(_PreviewError.default, {
        errorMessage: this._appStore.previewError
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._appStore.showFullScreenModal && /*#__PURE__*/_react.default.createElement(_fullScreenModal.default, null), /*#__PURE__*/_react.default.createElement(_reactSwipeable.Swipeable, {
      className: (0, _classnames.default)(["sdk-Preview-preview", "sdk-Preview-previewTop", hideCSS && "sdk-Preview-hide"]),
      onSwiped: eventData => {
        if (this._appStore.inFullScreen && eventData.dir === "Down") {
          this._appStore.setInFullScreen(false);
        }
      }
    }, _ComponentRegistry.default.getComponent("Preview", _objectSpread({
      previewDropin: this.previewDropin
    }, this.props))));
  }
  render() {
    const previewClasses = ["sdk-Preview-main"];
    if (this._appStore.getActionConfig("preview").enableModernViewer && (0, _AppUtil.isMobileBrowser)()) {
      previewClasses.push("mobile-modern-style");
    }
    const config = this._appStore.getConfig();
    if (this.previewDropin) {
      return config.isViewSDKPublic ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getComponent()) : /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(previewClasses)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sdk-Preview-middle"
      }, this.getComponent()));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "setPreviewDropin", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "setPreviewDropin"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "previewDropin", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class;